import { Button } from "@trafficsharkdsp/ui";
import cl from "classnames";
import toast from "react-hot-toast";

import CloseIcon from "../assets/icons/closeIcon.svg";

import cls from "./toaster.module.css";

import ErrorIcon from "@/shared/assets/icons/errorIcon.svg";
import SuccessIcon from "@/shared/assets/icons/successIcon.svg";

export const showToast = (type: "success" | "error", message: string, dataQa?: string) => {
    const resolvedQa = dataQa ?? (type === "success" ? "toast-success" : "toast-error");
    toast.custom((t) => (
        <div
            className={cl(
                cls["custom-toast"],
                type === "success" ? cls["custom-toast-success"] : cls["custom-toast-error"],
            )}
            data-qa={resolvedQa}
        >
            <div className={cls["toast-content"]}>
                {type === "success" ? <SuccessIcon /> : <ErrorIcon />}
                <span>{message}</span>
            </div>
            <Button
                type="link"
                className={cls["toast-close"]}
                data-qa="toast-close-button"
                onClick={() => toast.dismiss(t.id)}
            >
                <CloseIcon />
            </Button>
        </div>
    ));
};
